import React, { Component } from 'react';
import { Input, InputNumber, Spin, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import jquery from 'jquery';
import G6Editor from '@antv/g6-editor';
import DetailPanel from './DetailPanel';
import ContextMenu from './ContextMenu';
import ItemPanel from './ItemPanel';
import Page from './Page';
import './style.less';

G6Editor.track(false);

class FlowModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            selectedModel: {}, // 当前选中项数据模型
        };
    }

    toggleGrid(ev) {
        const editor = this.editor;
        const page = editor.getCurrentPage();
        if (ev.target.checked) {
            page.showGrid();
        } else {
            page.hideGrid();
        }
    }

    updateGraph(key, value) {
        const editor = this.editor;
        editor.executeCommand(() => {
            const page = editor.getCurrentPage();
            const selectedItems = page.getSelected();
            selectedItems.forEach(item => {
                const updateModel = {};
                updateModel[key] = value;
                page.update(item, updateModel);
            });
        });
    }

    componentWillMount() {
        this.editor = new G6Editor();
    }

    componentDidMount() {
        const editor = this.editor;
        const pages = editor.getComponentsByType('page');
        pages.forEach(page => {
            page.on('afteritemselected', ev => {
                this.setState({
                    selectedModel: ev.item.getModel()
                }, () => {
                    this.setState((prevState) => ({
                        inputingLabel: prevState.selectedModel.label || null
                    }));
                });
            });
        });
        const page = editor.getCurrentPage();
        page.changeAddEdgeModel({
            shape: 'flow-polyline-round'
        });
        this.queryData(this.props.params);
    }

    componentWillReceiveProps(nextProps) {
        const { isSave, isShow } = this.props;
        if (!isSave && nextProps.isSave) {
            this.save();
        }
        if (!isShow && nextProps.isShow) {
            this.queryData(nextProps.params);
        }
    }

    queryData = (params) => {
        const editor = this.editor;
        const page = editor.getCurrentPage();
        editor.executeCommand('resetZoom');
        page.read("{}");
        if (!params.ssuHospitalStructureId) {
            return;
        }
        this.setState({
            loading: true,
            selectedModel: {},
        });
        const options = {
            method: 'POST',
            url: API_URL.hospital.querySsuFlowChart,
            data: {
                ssuHospitalStructureId: params.ssuHospitalStructureId,
            },
            dataType: 'json',
            doneResult: res => {
                if (res.data) {
                    page.read(JSON.parse(res.data.ssuFlowChartStartValue));
                }
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    save = () => {
        const { params } = this.props;
        const newParams = {
            remark: params.remark,
            hospitalId: params.hospitalId,
            ssuModuleStructureId: params.ssuModuleStructureId,
            ssuModuleStructureDefineId: params.ssuModuleStructureDefineId,
        }
        if (params.ssuHospitalStructureId) {
            newParams.ssuHospitalStructureId = params.ssuHospitalStructureId;
        }

        const editor = this.editor;
        const page = editor.getCurrentPage();
        newParams.startValue = JSON.stringify(page.save());

        const iframes = document.querySelectorAll('iframe');
        const iframesArray = iframes ? Array.from(iframes) : [];
        iframesArray.forEach(i => i.remove());

        editor.executeCommand('autoZoom');

        const canvas = jquery("#screenshots canvas")[0];
        const url = canvas.toDataURL("image/png");
        newParams.ssuFlowChartScreenshot = url;

        const options = {
            method: 'POST',
            url: API_URL.hospital.addSsuFlowChart,
            data: {
                ...newParams,
            },
            dataType: 'json',
            doneResult: res => {
                if (!res.error) {
                    message.success(res.success);
                    this.props.hide({
                        [`${params.ssuModuleStructureDefineId}_flow`]: url,
                    }, params.ssuModuleStructureDefineId, res.ssuHospitalStructureId);
                }
            },
            errorResult: () => {
                this.props.hide();
            }
        };
        $.sendRequest(options);
    }

    getNodeList = () => {
        const { list } = this.props;
        const content = list.map((item, index) =>
            <div
                key={index}
                draggable="false"
                data-type="node"
                data-shape="flow-rect"
                data-size="80*48"
                data-color="#1890FF" 
                data-label={item}
                className="getItem item"
                title={item}
            >{item}</div>
        );
        return content;
    }

    render() {
        const { loading, inputingLabel, selectedModel } = this.state;
        const splitSize = selectedModel.size ? selectedModel.size.split('*') : '';
        const width = splitSize[0];
        const height = splitSize[1];
        const showInput = !!Object.keys(selectedModel).length;
        let name;
        if (showInput) {
            if (selectedModel.type == 'node') {
                name = '节点文字';
            } else {
                name = '连接线文字';
            }
        }
        const labelInput = (
            <div className="p">
                <p>{name}</p>
                <Input
                    size="small"
                    className="input name-input"
                    value={inputingLabel}
                    disabled={true}
                    onChange={ev => {
                        this.setState({
                        inputingLabel: ev.target.value
                        });
                    }}
                    onBlur={ev => {
                        this.updateGraph('label', ev.target.value);
                        this.setState({
                        selectedModel: {},
                        inputingLabel: null,
                        });
                    }}
                />
            </div>
        );
        const isShow = selectedModel && selectedModel.shape != "flow-polyline-round";
        return (
            <Spin spinning={loading}>
                <div className="editor flowChartCommon">
                    <div className="bottom-container">
                        <ContextMenu editor={this.editor} />
                        <ItemPanel editor={this.editor} content={
                            <div>{this.getNodeList()}</div>
                        }
                        />
                        <DetailPanel
                            editor={this.editor}
                            content={
                                <div>
                                    <div data-status="node-selected" className="panel">
                                        <div className="panel-title">属性</div>
                                        {
                                            showInput &&
                                            <div className="block-container">
                                                {labelInput}
                                                {
                                                isShow &&
                                                <div className="p">
                                                    尺寸：
                                                    <InputNumber
                                                    size="small"
                                                    value={width} className="input width-input"
                                                    onChange={ value => {
                                                        const newSize = value + '*' + height;
                                                        selectedModel.size = newSize;
                                                        this.setState({
                                                        selectedModel
                                                        });
                                                        this.updateGraph('size', newSize);
                                                    } }/>
                                                    <InputNumber
                                                    size="small"
                                                    value={height} className="input height-input"
                                                    onChange={ value => {
                                                        const newSize = width + '*' + value;
                                                        selectedModel.size = newSize;
                                                        this.setState({
                                                        selectedModel
                                                        });
                                                        this.updateGraph('size', newSize);
                                                    } }/>
                                                </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        />
                        <Page editor={this.editor} />
                    </div>
                </div>
            </Spin>
        )
    }
}

export default FlowModal


// WEBPACK FOOTER //
// ./src/components/common/flowChart/index.js